import { useState, type FormEvent } from 'react'
import { VivaLockup } from '@web/components/brand/Logo'
import { Button } from '@web/components/ui/Button'
import { ApiClientError } from '@web/lib/api'
import { useLogin } from '@web/lib/auth'

export function LoginPage() {
  const login = useLogin()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const error = login.error
  const message =
    error instanceof ApiClientError
      ? error.code === 'RATE_LIMITED'
        ? 'Too many tries. Wait a few minutes and try again.'
        : error.message
      : error
        ? 'Could not reach the server. Check your connection.'
        : null

  function onSubmit(event: FormEvent) {
    event.preventDefault()
    // Trimmed here as well as on the server: a paste with a stray space
    // or slash should never come back as "your password is wrong".
    login.mutate({ email: email.trim(), password })
  }

  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col justify-center px-6 pt-[var(--safe-top)] pb-[var(--safe-bottom)]">
      <div className="mb-9 text-center">
        <VivaLockup />
        <p className="mt-6 font-display text-xl text-ink-700">Bem-vinda de volta.</p>
      </div>

      <form onSubmit={onSubmit} className="space-y-4" noValidate>
        <div>
          <label htmlFor="email" className="mb-1.5 block text-sm font-medium text-ink-700">
            Email
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoComplete="username"
            inputMode="email"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            className="min-h-12 w-full rounded-xl bg-white px-4 text-base ring-1 ring-sand-200 focus:ring-2 focus:ring-brand-600"
          />
        </div>

        <div>
          <label htmlFor="password" className="mb-1.5 block text-sm font-medium text-ink-700">
            Password
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            className="min-h-12 w-full rounded-xl bg-white px-4 text-base ring-1 ring-sand-200 focus:ring-2 focus:ring-brand-600"
          />
        </div>

        {message && (
          <p role="alert" className="rounded-xl bg-red-50 px-4 py-3 text-sm text-red-800">
            {message}
          </p>
        )}

        <Button type="submit" size="lg" loading={login.isPending} className="w-full">
          Sign in
        </Button>
      </form>
    </main>
  )
}
